import styled from 'styled-components'

export const PopoverContainer = styled.div`
    .table {
        width: 350px;

        tr {
            cursor: pointer;
        }

        .disabled {
            pointer-events: none;
        }
    }
`

export default styled.div`
`
